import Axios from '../Axios';

const consumption = {
	create(data) {
		return Axios.post('/consumptions', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/consumptions?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/consumptions/' + id);
	},
	update(id, data) {
		return Axios.put('/consumptions/' + id, data);
	},
	delete(id) {
		return Axios.delete('/consumptions/' + id);
	},
};

export default consumption;
